import { GetSearchResultsRequest } from "../api/requests/get-search-results";
import { ErrorResponseWrapper } from "../api/errors/error-response-wrapper";
import config from "../environment/environment-config";

export const FETCH_SEARCH_RESULTS_BEGIN = "FETCH_SEARCH_RESULTS_BEGIN";
export const FETCH_SEARCH_RESULTS_SUCCESS = "FETCH_SEARCH_RESULTS_SUCCESS";
export const FETCH_SEARCH_RESULTS_FAILURE = "FETCH_SEARCH_RESULTS_FAILURE";

export const fetchSearchResultsBegin = (request) => ({
  type: FETCH_SEARCH_RESULTS_BEGIN,
  payload: { request },
});

export const fetchSearchResultsSuccess = (searchResultsResponse) => ({
  type: FETCH_SEARCH_RESULTS_SUCCESS,
  payload: { searchResultsResponse },
});

export const fetchSearchResultsFailure = (errors) => ({
  type: FETCH_SEARCH_RESULTS_FAILURE,
  payload: { errors },
});

export const SEARCH_BASE_URL = config.apiUrls.searchApi;

/**
 * @jsdoc method
 * @name getSearchResults
 * @methodOf actions.searchActions
 * @description
 * Fetches search results for search criteria
 */
export function getSearchResults(request: GetSearchResultsRequest) {
  const url =
    SEARCH_BASE_URL +
    "/autocomplete/BoschSearchBox" +
    request.toAutosuggestionsQueryString();

  return (dispatch) => {
    dispatch(fetchSearchResultsBegin(request));
    return fetch(url, { credentials: "same-origin" })
      .then((res) => {
        if (!res.ok) {
          throw new ErrorResponseWrapper(res);
        }
        return res.json();
      })
      .then((data) => {
        dispatch(fetchSearchResultsSuccess(data));
      })
      .catch((errorResponse: ErrorResponseWrapper) => {
        errorResponse.getErrorMessages().then((messages) => {
          dispatch(fetchSearchResultsFailure(messages));
        });
      });
  };
}
